import { InjectionToken } from '@angular/core';

/**
 * Base domain for the Firebase custom token endpoint.
 * Should be the full URL without the path, e.g., 'https://mission-control-api-demo.vendasta-internal.com'
 * Required when using FirebaseCustomAuthService.
 */
export const FIREBASE_AUTH_CUSTOM_TOKEN_DOMAIN = new InjectionToken<string>(
  'FIREBASE_AUTH_CUSTOM_TOKEN_DOMAIN',
);

